import {Component, Input, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import { MatDialog } from '@angular/material/dialog';
import {Store} from "@ngrx/store";
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import { PageNotificationService, AuthService} from '@signature-it/ngx-generic/services';
import { IUser } from '@signature-it/ngx-generic/interfaces';
import { UserLoginComponentGeneric } from '@signature-it/ngx-generic/components/user-login';
import { FakeloaderComponent} from '@signature-it/ngx-generic/components/fakeloader';
import { AddToSuccessModalComponentGeneric } from '@signature-it/ngx-catalogue/components/success-modal';
import { CatalogueActions } from '@signature-it/ngx-catalogue/store/actions';
import { CatalogueSelectors } from '@signature-it/ngx-catalogue/store/selectors';

@Component({
    selector: 'add-to-favorite',
    templateUrl: './add-to-favorite.html',
    standalone: false
})
export class AddToFavoriteComponent_Generic implements OnInit{

    @Input() productId;
    favoritesPage = false;
    isAdded = false;
    key = '';
    favoritesIds$: Observable<any>;
    loadingFavorites$: Observable<any>
    addFavoritesSuccess$: Observable<boolean>;
    removeFavoritesSuccess$: Observable<boolean>;
    unSubscriber = new Subject();
    private destroy$: Subject<void> = new Subject<void>();
    private remove$: Subject<void> = new Subject<void>();

    constructor(protected notifySvc: PageNotificationService,
                public dialog: MatDialog,
                protected authSvc: AuthService,
                private router: Router,
                protected store$: Store<any>) {
        this.favoritesIds$ = this.store$.select(CatalogueSelectors.getFavoritesIds);
        this.loadingFavorites$ = this.store$.select(CatalogueSelectors.loadingFavoritesList);
        this.addFavoritesSuccess$ = this.store$.select(CatalogueSelectors.updatedFavoritesSuccess);
        this.removeFavoritesSuccess$ = this.store$.select(CatalogueSelectors.removeFavoritesSuccess);
    }

    ngOnInit(){
        this.productId = parseInt(this.productId);
        this.checkIsAdded();

        if(this.router.url.includes('favorites')) {
            this.favoritesPage = true;
        }
    }

    get isUserAuthenticated() {
        return UserLoginComponentGeneric.userAuthenticated;
    }

    checkIsAdded() {
        this.authSvc.currentUsersData$.subscribe((user: IUser) => {
            if(user && user.user_id && user.user_id > 0){
                this.store$.dispatch(CatalogueActions.getFavorites());
            }
        });
    }

    removeFavorite() {
        FakeloaderComponent.start();
        const actionRemoveFavorite = CatalogueActions.removeFavorite({'productIds': [this.productId]});
        this.store$.dispatch(actionRemoveFavorite);
        if(!this.favoritesPage) {
            this.removeFavoritesSuccess$
                .pipe(takeUntil(this.remove$))
                .subscribe(isRemoved => {
                        if (isRemoved) {
                            this.openModal('Removed from My Favorites');
                            this.remove$.next();
                            this.remove$.complete();
                        }
                    },
                    err => {
                        this.notifySvc.set(err).show();
                    });
        }
        FakeloaderComponent.stop();
    }


    addFavorite() {
        FakeloaderComponent.start();
        const actionAddFavorite = CatalogueActions.addFavorite({'productId': this.productId});
        this.store$.dispatch(actionAddFavorite);
        this.addFavoritesSuccess$
            .pipe(takeUntil(this.destroy$))
            .subscribe(isAdded => {
                    if (isAdded) {
                        this.openModal('Added to My Favorites');
                        this.destroy$.next();
                        this.destroy$.complete();

                    }
                },
                err => {
                    this.notifySvc.set(err).show();
                });
        FakeloaderComponent.stop();
    }

    openModal(title) {
        const initialState = {
            title: title,
            redirectLink: '/account/favorites',
            redirectText: 'Go To My Favorites',
            continueText: 'Continue shopping'
        };
        this.dialog.open(
            AddToSuccessModalComponentGeneric,
            {data: initialState, maxWidth: 'none', maxHeight: 'none', panelClass: 'add-favorite-dialog'});
    }


}
